import { render, staticRenderFns } from "./EntryGuideTip.vue?vue&type=template&id=670d272a&"
import script from "./EntryGuideTip.vue?vue&type=script&lang=js&"
export * from "./EntryGuideTip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports